import { initRouting } from './routing/index';

export function createCoreServices (app) {
  initRouting(app);
}
